
export interface MentionUser {
  id: string;
  displayName: string;
  avatarUrl?: string | null;
}

export const MENTION_TOKEN_RE = /@\[([0-9a-fA-F-]{36}|anon-[0-9a-f]{12})\]/g;

export type MentionPart =
  | { type: 'text'; value: string }
  | { type: 'mention'; id: string; displayName: string | null };

export function splitMentions(text: string, mentions?: MentionUser[]): MentionPart[] {
  if (!text.includes('@[')) return [{ type: 'text', value: text }];
  const names = new Map((mentions ?? []).map((m) => [m.id, m.displayName]));
  const parts: MentionPart[] = [];
  let last = 0;
  for (const match of text.matchAll(MENTION_TOKEN_RE)) {
    const start = match.index ?? 0;
    if (start > last) parts.push({ type: 'text', value: text.slice(last, start) });
    parts.push({ type: 'mention', id: match[1], displayName: names.get(match[1]) ?? null });
    last = start + match[0].length;
  }
  if (last < text.length) parts.push({ type: 'text', value: text.slice(last) });
  return parts;
}

export function mentionsUser(text: string, userId: string): boolean {
  return text.includes(`@[${userId}]`);
}

export const mentionLabel = (displayName: string) => `@${displayName}`;

export function textToTokens(text: string, picked: Map<string, string>): string {
  if (picked.size === 0) return text;
  let out = text;
  const names = [...picked.keys()].sort((a, b) => b.length - a.length);
  for (const name of names) {
    out = out.split(mentionLabel(name)).join(`@[${picked.get(name)!}]`);
  }
  return out;
}

export function tokensToText(
  text: string,
  mentions?: MentionUser[],
): { text: string; picked: Map<string, string> } {
  const picked = new Map<string, string>();
  const out = splitMentions(text, mentions)
    .map((part) => {
      if (part.type === 'text') return part.value;
      if (!part.displayName) return '';
      picked.set(part.displayName, part.id);
      return mentionLabel(part.displayName);
    })
    .join('');
  return { text: out, picked };
}
